import { useMemo } from "react";
import { Box, HStack, Text } from "@chakra-ui/react";
import { RSelect, OptionLabel } from "../Select/RSelect";
import Button from "../Button/Button";
// import BTC from "../../assets/svg/bitcoin.svg";
// import ETH from "assets/svg/ethw.svg";
// import CELO from "assets/svg/icons-new/celo.svg";
import { ReactComponent as Circle } from "assets/svg/paint-circle.svg";

import useCoinInfo from "hooks/useCoinInfo";
import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
import isEmpty from "lodash/isEmpty";

// const options = [
//   {
//     label: <OptionLabel label={"BTC"} img={BTC} />,
//     value: "btc",
//   },
//   {
//     label: <OptionLabel label={"ETH"} img={ETH} />,
//     value: "eth",
//   },
//   {
//     label: <OptionLabel label={"CELO"} img={CELO} />,
//     value: "celo",
//   },
// ];

const InvestWallet = ({
  onRequest,
  onPayback,
  isRequestDisabled,
  isPaybackDisabled,
  onSelect,
  coin,
  balance,
  availableCoins,
  label,
  buttonText,
  actions,
}) => {
  const { getWalletInfo } = useCoinInfo();
  // const [coin, setCoin] = useState(defaultCoin ?? "btc");

  // console.log("COIN", coin);

  const handleSelect = (value) => {
    // setCoin(value);
    onSelect && onSelect(value);
  };

  const options = useMemo(() => {
    return (availableCoins ?? []).map((coin) => ({
      label: (
        <OptionLabel
          label={toCoinLocale(coin)}
          img={getWalletInfo(coin).image}
        />
      ),
      value: coin,
    }));
  }, [getWalletInfo, availableCoins]);

  const defaultValue = useMemo(
    () => options.find((option) => option.value === (coin ?? "btc")),
    [options, coin]
  );

  console.log("DEFAULT INVEST VALUE", defaultValue, coin);

  return (
    <Box
      bg="linear-gradient(114.44deg, #027343 0%, #02AA63 100%)"
      p="16px 20px"
      borderRadius="10px"
      pos="relative"
      //   overflow="hidden"
    >
      <Box
        borderRadius="10px"
        pos="absolute"
        right="0"
        bottom="0"
        opacity="0.2"
        overflow="hidden"
        // maxH="80px"
      >
        <Box as={Circle} color="#027343" />
      </Box>
      <HStack justifyContent="space-between">
        <Text fontSize="13px" color="#ffffff8f" fontWeight="600">
          {label ?? "Loan Wallet"}
        </Text>
        <RSelect
          onChange={(e) => handleSelect(e.value)}
          container={{ width: "110px", height: "32px", minHeight: "32px" }}
          control={{
            height: "32px",
            minHeight: "32px",
            padding: "0 5px",
            borderRadius: "5px",
            background: "#ffffff1f",
            ":hover": {
              background: "#ffffff1f",
            },
          }}
          valueContainer={{
            padding: "0 !important",
            color: "white",
            flexWrap: "nowrap",
            fontSize: "14px",
            ".chakra-stack": {
              gridGap: "2px",
            },
          }}
          dropdownIndicator={{ padding: "0 !important" }}
          isSearchable={false}
          options={options}
          defaultValue={defaultValue}
        />
      </HStack>
      <Text py="10px" color="white" fontSize="20px" fontWeight="600">
        {toPrecision(balance ?? 0, coin ?? "btc")}
      </Text>

      {!actions && (
        <HStack>
          <Button
            borderRadius="10px"
            bg="#ffffff15"
            minH="45px"
            flex="1"
            fontSize="14px"
            fontWeight="500"
            disabled={isPaybackDisabled}
            onClick={onPayback}
          >
            {(buttonText && buttonText[0] && buttonText[0]) ?? "Payback"}
          </Button>
          <Button
            borderRadius="10px"
            bg="#ffffff15"
            minH="45px"
            flex="1"
            fontSize="14px"
            fontWeight="500"
            disabled={isRequestDisabled}
            onClick={onRequest}
          >
            {(buttonText && buttonText[1] && buttonText[1]) ?? "Request"}
          </Button>
        </HStack>
      )}

      {actions && !isEmpty(actions) && (
        <HStack>
          {actions.map(({ label, ...action }, i) => (
            <Button
              key={`action-${i}`}
              borderRadius="10px"
              bg="#ffffff15"
              minH="45px"
              flex="1"
              fontSize="14px"
              fontWeight="500"
              {...action}
            >
              {label}
            </Button>
          ))}
        </HStack>
      )}
    </Box>
  );
};

export default InvestWallet;
